import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import GenericButton, { type GenericButtonProps } from 'src/components/GenericButton';
import { ModalHeaderDescriptionRow as ModalHeaderDescBase } from 'src/components/ModalLayout';
import { useHasInventoryItem } from 'src/hooks/useInventoryItem';
export interface ModalProps {
  onSave: () => void;
  onClose?: () => void;
  landFrom: 'MIRROR' | 'FINDING';
}
export const ModalHeaderDescriptionRow = styled(ModalHeaderDescBase)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
`;
export const ButtonErrorText = styled.span`
  font-weight: 400;
  margin-top: 1.36px;
  display: flex;
  align-items: center;
  font-size: 10px;
  line-height: 12px;
`;
const SaveButtonBase = styled(GenericButton)`
  margin-top: 18px;
`;
export const SaveButton = (props: Omit<GenericButtonProps, 'children' | 'size' | 'variant'>) => {
  const {
    t
  } = useTranslation();
  const isSubscribed = useHasInventoryItem('VIVIDI_UNLIMITED');
  return <SaveButtonBase size='large' variant='primary' {...props} data-sentry-element="SaveButtonBase" data-sentry-component="SaveButton" data-sentry-source-file="Modal.tsx">
      {isSubscribed ? t('vividi_filter_sheet_btn_save') : t('vividi_filter_sheet_btn_upgrade')}
    </SaveButtonBase>;
};